export default __webpack_public_path__ + "static/ellengwhite-b54feb7fc52ae896edebff14e901c2dd.jpg";